import React from "react";

export function Input(props) {
  const { defaultValue, value, size, disabled, type, onChange, ...rest } =
    props;
  // const [textValue, setTextValue] = useState(value || defaultValue || '');
  let classes = "chonos-input";
  if (size) {
    classes += ` chronos-input-${size}`;
  }

  const handleChange = (ev) => {
    // if (rest.min && rest.max) {
    //   const value =
    //   console.log("Handle min max", ev);
    // }

    onChange(ev);
  };
  return (
    <input
      className={classes}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
      type={type ? type : "text"}
      onChange={handleChange}
      {...rest}
    />
  );
}
